import { Button } from 'antd';
import { TestType } from 'procura-shared';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import calls from '../api/calls';

type RunTestButtonProps = {
  type: TestType;
};

export const RunTestButton = ({ type }: RunTestButtonProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const buttonClickHandler = async () => {
    setLoading(true);
    try {
      await calls.tests.runInvestmentsTest();
    } finally {
      setLoading(false);
    }
  };

  const buttonLabel = (): string => {
    switch (type) {
      default:
      case 'Investments':
        return loading ? t('runInvestmentTestLoading') : t('runInvestmentTest');
    }
  };

  return (
    <>
      <Button type="ghost" style={{ width: '100%', marginBottom: 16 }} onClick={buttonClickHandler} loading={loading}>
        {buttonLabel()}
      </Button>
    </>
  );
};
